<template>
	<div id="qrcode" style="width:200px; height:200px; margin: auto;margin-bottom: 40px;"></div>
</template>

<script>
import QRCode from "../../plugins/external/qrcode.js";

export default {
	name: "giro-pay-qr",

    props: {
        iban: {
            type: String,
            required: true
        },
		bic: {
            type: String,
            required: true
        },
		name: {
            type: String,
            required: true
        },
		orderId: {
            type: String,
            required: true
        },
		amount: {
            type: String,
            required: true
        },
		currency: {
            type: String,
            required: true
        },
    },

	data() {
		return {
			qrCodeGenerator: null
		};
	},

	methods: {
		generateQrCode() {
			if (!isNaN(this.orderId) && this.qrCodeGenerator !== null) {
				this.qrCodeGenerator.makeCode(
					"BCD\n001\n1\nSCT\n" +
					this.bic + "\n" +
					this.name + "\n" +
					this.iban + "\n" +
					this.currency + this.amount + "\n" +
					"\n" +
					this.orderId
				);
			}
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.qrCodeGenerator = new QRCode(document.getElementById("qrcode"), {
				width: 220,
				height: 220
			});

			this.generateQrCode();
		});
	}
};
</script>
